module.exports = __webpack_public_path__ + "img/reserved_selected.432ee4c0.svg";